import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import RegisterStudent from "@/pages/RegisterStudent";
import RegisterAdmin from "@/pages/RegisterAdmin";
import PendingApproval from "@/pages/PendingApproval";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import Students from "@/pages/admin/Students";
import Exams from "@/pages/admin/Exams";
import ExamBuilder from "@/pages/admin/ExamBuilder";
import QuestionBank from "@/pages/admin/QuestionBank";
import Evaluations from "@/pages/admin/Evaluations";
import Analytics from "@/pages/admin/Analytics";
import Admins from "@/pages/admin/Admins";

import StudentDashboard from "@/pages/student/StudentDashboard";
import StudentExams from "@/pages/student/StudentExams";
import ExamAttempt from "@/pages/student/ExamAttempt";
import StudentResults from "@/pages/student/StudentResults";
import ResultDetail from "@/pages/student/ResultDetail";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<RegisterStudent />} />
          <Route path="/register/admin" element={<RegisterAdmin />} />
          <Route path="/pending" element={<PendingApproval />} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/students" element={<ProtectedRoute role="admin"><Students /></ProtectedRoute>} />
          <Route path="/admin/exams" element={<ProtectedRoute role="admin"><Exams /></ProtectedRoute>} />
          <Route path="/admin/exams/:id" element={<ProtectedRoute role="admin"><ExamBuilder /></ProtectedRoute>} />
          <Route path="/admin/question-bank" element={<ProtectedRoute role="admin"><QuestionBank /></ProtectedRoute>} />
          <Route path="/admin/evaluations" element={<ProtectedRoute role="admin"><Evaluations /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute role="admin"><Analytics /></ProtectedRoute>} />
          <Route path="/admin/admins" element={<ProtectedRoute role="admin"><Admins /></ProtectedRoute>} />

          {/* Student */}
          <Route path="/app" element={<ProtectedRoute role="student"><StudentDashboard /></ProtectedRoute>} />
          <Route path="/app/exams" element={<ProtectedRoute role="student"><StudentExams /></ProtectedRoute>} />
          <Route path="/app/attempt/:id" element={<ProtectedRoute role="student"><ExamAttempt /></ProtectedRoute>} />
          <Route path="/app/results" element={<ProtectedRoute role="student"><StudentResults /></ProtectedRoute>} />
          <Route path="/app/results/:id" element={<ProtectedRoute role="student"><ResultDetail /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
